/** @format */

import { APP_ID, ErrorHandler, NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
  withNoHttpTransferCache,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { Chain, Environment, LocalStorageConfig } from '@shared/data-access/interfaces';
import { GlobalErrorHandler, LogDataAccessModule } from '@logger';
import { LoggerConfig, WindowModule } from '@shared/data-access/services';
import { RouterModule, Routes } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { APP_BASE_HREF } from '@angular/common';
import { AppComponent } from './app.component';
import { AppHomefieldIconsModule } from './app.homefield-icons.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CeopsComponent } from '@shared/ceops';
import { DCSG_APP_NAME } from '@shared/data-access/constants';
import { GoogleAdManagerComponent } from '@shared/components/google-ad-manager';
import { HomeComponent } from './views/home/home-component/home.component';
import { HomeModule } from './views/home/home.module';
import { HomrContentResolve } from './common/resolve/homr.resolve';
import { MatSelectModule } from '@angular/material/select';
import { NoContentComponent } from './views/no-content/no-content.component';
import { StaticComponent } from './views/static/static-component/static.component';
import { StaticModule } from './views/static/static.module';
import { chain } from '@core/chain';
import { environment } from '../environments';

const APP_ROUTES: Routes = [
  {
    path: 's/:seoName',
    component: StaticComponent,
    resolve: {
      homrData: HomrContentResolve,
    },
  },
  {
    path: '',
    component: HomeComponent,
    resolve: {
      homrData: HomrContentResolve,
    },
  },
  { path: 'search/SearchDisplay', component: NoContentComponent },
  { path: '404', component: NoContentComponent },
  { path: '**', component: NoContentComponent },
];

/*
 * App Configs
 */
const LOCAL_STORAGE_CONFIG: LocalStorageConfig = {
  prefix: '',
};

const LOGGER_CONFIG: LoggerConfig = {
  clientLoggerLevel: environment.logging.client.level,
  xhrLoggerLevel: environment.logging.xhr.level,
  xhrLoggerUrl: ``,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppHomefieldIconsModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(APP_ROUTES, {
      useHash: false,
      onSameUrlNavigation: 'ignore',
      enableTracing: false,
    }),
    CeopsComponent,
    GoogleAdManagerComponent,
    HomeModule,
    LogDataAccessModule.forRoot(LOGGER_CONFIG),
    WindowModule.forRoot(LOCAL_STORAGE_CONFIG),
    MatSelectModule,
    StaticModule,
  ],
  providers: [
    { provide: APP_ID, useValue: 'dcsg-ngx-home' },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: Chain, useValue: chain || {} },
    { provide: DCSG_APP_NAME, useValue: 'HOME' },
    { provide: Environment, useValue: environment || {} },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideClientHydration(
      withNoHttpTransferCache(),
      withEventReplay(),
      withNoIncrementalHydration(),
    ),
  ],
  bootstrap: [AppComponent],
})
export class AppBrowserModule {}
